export default "__VITE_ASSET__DrsC8ciR__"